import { useState } from 'react';
import { Button, Input, Label } from '@accure/ui';

import { useMe } from '@/hooks/use-me';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/modules/siteview/components/ui/card';

import { UpdateUserInfo } from '../mutations';

export function BasicInfoSection() {
  const me = useMe();
  const [showBasicInfoSuccess, setShowBasicInfoSuccess] = useState(false);
  const [firstName, setFirstName] = useState(me.firstName);
  const [lastName, setLastName] = useState(me.lastName);

  const updateUserInfoMutation = UpdateUserInfo.useMutation();

  const basicInfoButtonText = updateUserInfoMutation.isLoading
    ? 'Saving...'
    : 'Save Changes';

  const hasChanges = firstName !== me.firstName || lastName !== me.lastName;
  const isDisabled = updateUserInfoMutation.isLoading || !hasChanges;

  const handleBasicInfoClick = async () => {
    try {
      await updateUserInfoMutation.mutateAsync({
        firstName,
        lastName,
      });
      setShowBasicInfoSuccess(true);
      setTimeout(() => {
        setShowBasicInfoSuccess(false);
      }, 3000);
    } catch (error) {
      console.error('Failed to update user info:', error);
    }
  };

  return (
    <Card data-testid="basic-info-section">
      <CardHeader>
        <CardTitle>Basic Information</CardTitle>
        <CardDescription>
          Update your personal information and contact details
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="firstName">First Name</Label>
            <Input
              id="firstName"
              data-testid="first-name-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="lastName">Last Name</Label>
            <Input
              id="lastName"
              data-testid="last-name-input"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email Address</Label>
          <Input
            id="email"
            type="email"
            data-testid="email-input"
            disabled
            defaultValue={me.email}
          />
        </div>
        <div className="flex items-center gap-3">
          <Button
            data-testid="basic-info-save-button"
            onClick={handleBasicInfoClick}
            disabled={isDisabled}
          >
            {basicInfoButtonText}
          </Button>
          {showBasicInfoSuccess && (
            <div
              data-testid="basic-info-save-success-message"
              className="text-sm text-primary-500"
            >
              Basic information updated!
            </div>
          )}
        </div>
        {updateUserInfoMutation.error != null && (
          <div
            data-testid="basic-info-error-message"
            className="mt-2 text-sm text-red-500"
          >
            Failed to save basic information. Please try again.
          </div>
        )}
      </CardContent>
    </Card>
  );
}
